import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { VoucherService } from '@app/modules/core/services/vouchers/vouchers.service';

const SCOPE_ONLY_WASH = 3;
const SCOPE_ONLY_ITV = 21;
const SCOPE_ONLY_MAINTENANCES = 22;
const SCOPE_REFUELING = [23, 24, 25, 26, 27, 28, 29];
const SCOPE_CARSERVICE = [5, 20, 21, 22, ...SCOPE_REFUELING];

@Component({
  selector: 'bkg-voucher-list',
  templateUrl: './voucher-list.component.html',
  styleUrls: ['./voucher-list.component.scss'],
  providers: [DatePipe]
})
export class VoucherListComponent implements OnInit {
  @Input() vouchers: any[] = [];
  @Input() selectedVoucherCode: string | null = null;

  @Output() addVoucherCodeReturn = new EventEmitter<string>();

  constructor(
    private translate: TranslateService,
    private datePipe: DatePipe,
    private voucherService: VoucherService
  ) { }

  ngOnInit(): void {
  }

  getCouponType(scope: string | string[]): 'wash' | 'carservice' | 'itv' | 'generic' | 'refueling' | 'maintenance' {
    if (!scope) return 'generic';
    const scopeArray = Array.isArray(scope) ? scope.map(Number) : scope.split(',').map(Number);
    if (scopeArray.every(s => s === SCOPE_ONLY_WASH)) return 'wash';
    if (scopeArray.every(s => s === SCOPE_ONLY_ITV)) return 'itv';
    if (scopeArray.every(s => s === SCOPE_ONLY_MAINTENANCES)) return 'maintenance';
    if (scopeArray.every(s => SCOPE_REFUELING.includes(s))) return 'refueling';
    if (scopeArray.every(s => SCOPE_CARSERVICE.includes(s))) return 'carservice';
    return 'generic';
  }

  getVoucherDiscountText(voucher: any): string {
    if (voucher.dto) {
      const value = parseFloat(voucher.dto);
      return this.translate.instant('sharedModule.bkgSummaryVouchers.discount_percent', { value });
    } else if (voucher.dto_euro) {
      const value = parseFloat(voucher.dto_euro);
      return this.translate.instant('sharedModule.bkgSummaryVouchers.discount_euro', { value });
    } else {
      return this.translate.instant('sharedModule.bkgSummaryVouchers.discount_available');
    }
  }

  getVoucherExpirationText(endDate: string): string {
    const dateFormatted = this.datePipe.transform(endDate, 'dd-MM-yyyy');
    return this.translate.instant('sharedModule.bkgSummaryVouchers.expires_on', { date: dateFormatted });
  }

  onCouponSelected(code: string): void {
    if (this.selectedVoucherCode === code) return;
    this.voucherService.setSelectedVoucherCode(code);
    this.addVoucherCodeReturn.emit(code);
  }
}
